import { Backdrop, CircularProgress } from '@mui/material';
import { useSelector } from 'react-redux';
import { IRootState } from '../../types/store';

export const BackdropLoader = () => {
  const isLoading = useSelector((state: IRootState) => state.user.isLoading);
  return (
    <>
      <Backdrop
        sx={(theme) => ({ color: '#fff', zIndex: theme.zIndex.modal + 10 })}
        open={isLoading}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
    </>
  );
};
